import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SharedServiceService } from '../../services/shared-service.service';

@Component({
  selector: 'app-disabled-user',
  templateUrl: './disabled-user.component.html',
  styleUrls: ['./disabled-user.component.scss'],
})
export class DisabledUserComponent implements OnInit, OnDestroy {

  @Input() mensajesConfiguracion = ''
  private clearNativeStorageSubscription: Subscription
  public configuracion = {
    boton_aceptar: 'Entendido',
    mensaje: ' Esta cuenta ha sido inhabilitada',
    titulo: '¡Lo sentimos!',
  }

  constructor(
    private sharedService: SharedServiceService
  ) { }

  ngOnInit() {
    if (this.mensajesConfiguracion !== '') {
      this.configuracion = JSON.parse(this.mensajesConfiguracion)
    }
  }

  ngOnDestroy() {
    if (this.clearNativeStorageSubscription) {
      this.clearNativeStorageSubscription.unsubscribe()
    }
  }

  public async logOut() {
    this.sharedService.emitMenu(false)
    await this.sharedService.clearData('login');
  }

}
